import { setRatingsLoaderTimer } from "src/global-helpers.js";

$(function(){
  $('.js-toggleBehancePopup').on('click', function(){
    $('.popup_behance_connection').addClass('opened');
  });

  setRatingsLoaderTimer();
});
